import { render, staticRenderFns } from "./GastroAnoRettoColonscopiaEditComponent.vue?vue&type=template&id=3e4728ba"
import script from "./GastroAnoRettoColonscopiaEditComponent.vue?vue&type=script&lang=js"
export * from "./GastroAnoRettoColonscopiaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports